/* MYNTELO v7 tile quick add (A.3, 2026-11-02). The round bag button of snippets/myntelo-v7-tile.liquid adds a variant through
   /cart/add.js with the drawer sections, so assets/myntelo-commerce.js opens the cart drawer at once (initInstantBag) and logs the
   add like every other add in the theme; the response is rendered into the drawer. A refused add shows its message in the drawer;
   with no drawer on the page the button opens the product instead.
   Model pick (2026-11-03, Danny): a product made in several models (button data-myn-pick, map in the tile's
   <script data-myn-models>: model -> [variant id, available]) is never added blind. The bag opens the "Choose your model" sheet of
   assets/myntelo-flow.js (window.MynteloPicker.pick, the same sheet as the v6 collection cards: suggested / popular / all models,
   the visitor's earlier pick pre-selected with "Add to bag · <model>" and Buy now, Clarity model_chosen); the picked model's
   variant is then added here (the drawer's loading line opens on the tap). Without the sheet on the page the button opens the
   product page. Known model: on the v7 model collection pages sections/myntelo-v7-collection.liquid rewrites the button to that
   model's variant (data-url ends in ?variant=), so that variant is added directly; one-variant products are added directly too. */
(function () {
  'use strict';
  if (window.mynV7Tile) return;
  window.mynV7Tile = true;
  var W = window, D = document, KEY = 'myntelo:device';
  var root = (W.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function known(b) { return /[?&]variant=\d/.test(b.dataset.url || ''); }
  function picks(b) { return b.hasAttribute('data-myn-pick') && !known(b); }
  function models(b) {
    if (!b._mynv) {
      var s = b.closest('.myn-tile'), j = s && s.querySelector('[data-myn-models]');
      try { b._mynv = JSON.parse(j.textContent); } catch (e) { b._mynv = {}; }
    }
    return b._mynv;
  }
  function done(b) { b.disabled = false; b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); }
  function busy(b) { b.disabled = true; b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true'); }

  function add(b, id) {
    var drawer = D.querySelector('cart-notification');
    if (!W.fetch || !drawer || typeof drawer.renderContents !== 'function') { location.href = b.dataset.url; return; }
    busy(b);
    if (drawer.setActiveElement) drawer.setActiveElement(b);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }], sections: 'myntelo-cart-drawer,cart-icon-bubble', sections_url: location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        done(b);
        if (res.ok && !res.j.status) drawer.renderContents(res.j);
      })
      .catch(function () { done(b); });
  }
  /* Buy now (model sheet): add this variant, then straight to checkout (same as assets/myntelo-collection.js) */
  function buyNow(b, id) {
    busy(b);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) { if (res.ok && !res.j.status) location.href = root + 'checkout'; else done(b); })
      .catch(function () { done(b); });
  }
  /* pre-select: the visitor's earlier pick, else the first screen-size candidate (assets/myntelo-device.js) made in this design */
  function preselect(open) {
    var pre = null;
    try { var p = JSON.parse(localStorage.getItem(KEY) || 'null'); if (p && open.indexOf(p.model) >= 0) pre = p.model; } catch (e) {}
    if (pre) return pre;
    try {
      var kind = /^Samsung Galaxy/i.test(open[0]) ? 'galaxy' : 'iphone';
      var ph = W.MynteloDevice && MynteloDevice.phoneFor && MynteloDevice.phoneFor(kind);
      if (ph) pre = (ph.cands || [ph.model]).filter(function (m) { return open.indexOf(m) >= 0; })[0] || null;
    } catch (e) {}
    return pre;
  }
  function choose(b) {
    var v = models(b), open = Object.keys(v).filter(function (m) { return v[m] && v[m][1]; });
    var picker = W.MynteloPicker;
    var ok = open.length && picker && typeof picker.pick === 'function' && picker.pick(open, preselect(open), function (m) {
      try { b.focus({ preventScroll: true }); } catch (x) {}
      if (v[m] && v[m][1]) add(b, v[m][0]);
    }, {
      onBuy: function (m) { if (v[m] && v[m][1]) buyNow(b, v[m][0]); }
    });
    if (!ok) location.href = b.dataset.url;
  }

  /* the button names what it does: "Choose your model for “Name”" where the sheet opens */
  function label() {
    [].forEach.call(D.querySelectorAll('[data-myn-pick]'), function (b) {
      if (b._mynl || !picks(b)) return;
      b._mynl = 1;
      b.setAttribute('aria-haspopup', 'dialog');
      if (b.dataset.pickLabel) b.setAttribute('aria-label', b.dataset.pickLabel);
    });
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', label); else label();
  D.addEventListener('shopify:section:load', label);

  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-myn-quick-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    if (picks(b)) { choose(b); return; }
    add(b, b.dataset.mynQuickAdd);
  });
})();
